import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Bell, ChevronLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import BottomNav from "@/components/BottomNav";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Layout = ({ children, title, showBack = false, hideNav = false, hideHeaderLogo = false, hideHeader = false }) => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user }  = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    axios.get(`${API}/notifications`, { withCredentials: true })
      .then(({ data }) => setUnread(data.unread || 0))
      .catch(() => {});
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#FAFAFC] text-slate-900">
      {/* Top Header — hidden when page provides its own header */}
      {!hideHeader && (
        <header className="fixed top-0 left-0 right-0 z-40 max-w-md mx-auto w-full">
          <div className="h-14 glass border-b border-slate-200/80 flex items-center justify-between px-4">
            {showBack ? (
              <button
                data-testid="back-button"
                onClick={() => navigate(-1)}
                className="p-2 -ml-2 rounded-xl hover:bg-slate-100 transition-colors text-slate-600"
              >
                <ChevronLeft size={22} />
              </button>
            ) : hideHeaderLogo ? (
              <div className="w-10" />
            ) : (
              <button onClick={() => navigate("/appmobile/dashboard")} className="flex items-center">
                <img
                  src="https://customer-assets-eiarnc6j.emergentagent.net/job_bompay-ledger/artifacts/v92480gb_BomPay.png"
                  alt="Bompay"
                  className="h-7 w-auto object-contain"
                />
              </button>
            )}

            {title && showBack && (
              <h1 className="text-sm font-semibold text-slate-900 absolute left-1/2 -translate-x-1/2">{title}</h1>
            )}

            <div className="flex items-center gap-1">
              <button
                onClick={() => navigate("/appmobile/notifications")}
                className="relative p-2 -mr-2 rounded-xl hover:bg-slate-100 transition-colors"
                data-testid="notifications-button"
              >
                <Bell size={20} className="text-slate-600" />
                {unread > 0 && (
                  <span className="absolute top-1.5 right-1.5 w-4 h-4 bg-[#064BCB] rounded-full flex items-center justify-center text-[9px] font-bold text-white">
                    {unread > 9 ? "9+" : unread}
                  </span>
                )}
              </button>
            </div>
          </div>
        </header>
      )}

      {/* Main content */}
      <main className={`max-w-md mx-auto px-4 pb-24 min-h-screen ${hideHeader ? "pt-0" : "pt-16"}`}>
        {children}
      </main>

      {/* Bottom Navigation */}
      {!hideNav && <BottomNav />}
    </div>
  );
};
export default Layout;
